import React from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import parseMediaUrl from "../../functions/parseMediaUrl";
import MediaDescriptionRender from "./MediaDescriptionRender";
import StaticBox from "../../../frontend/templates/StaticSlide/Box";

export function Item(props) {
  const {
    id,
    index,
    item,
    isDragging,
    isSorting,
    type,
    handleRemoveFromSlide,
    feedType,
    countries,
  } = props;
  const typeId = "uuid";
  const updatedAtPrefix = new Date(item.updatedAt).getTime();
  return (
    <div key={item.uuid} className={"media-item"}>
      <div className={"media-actions"}></div>
      <div className={"media-item-av"}>
        <img src={parseMediaUrl(item.url) + `?updated_at=${updatedAtPrefix}`} />
      </div>
      <div className="preview-box-container drag-item">
        <StaticBox
          slide={item}
          feedType={feedType}
          countries={countries}
          isPreview={true}
        />
      </div>
      <div className={"media-item-data"}>
        <MediaDescriptionRender item={item} />
      </div>
    </div>
  );
}
